import ReactDOM from "react-dom";
import { clsx } from "clsx";
import UploadProgressItem from "./UploadProgressItem";
import styles from "./upload-progress.module.scss";

interface IUploadProgress {
  files: {
    [key: string]: {
      name: string;
      size: number;
      progress: number;
    };
  };
  onCancel: (value: string) => void;
  elementId?: string;
  extraClass?: string;
}

const UploadProgress: React.FC<IUploadProgress> = ({
  files,
  onCancel,
  elementId,
  extraClass
}) => {
  const uploadProgress = (
    <div
      id="progress_bar_items"
      className={clsx(styles["upload-progress-container"], extraClass)}
    >
      <ul className={styles["upload-progress-list"]}>
        {Object.values(files || {}).map(file => (
          <UploadProgressItem
            key={file.name}
            size={file.size}
            progress={file.progress}
            name={file.name}
            onCancel={onCancel}
          />
        ))}
      </ul>
    </div>
  );

  if (!elementId) {
    return uploadProgress;
  }
  const uploadProgressPortalElement = document.getElementById(elementId);
  if (!uploadProgressPortalElement) {
    return null;
  }
  return ReactDOM.createPortal(uploadProgress, uploadProgressPortalElement);
};

export default UploadProgress;
